import { UserX } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * The dead end, shared by the two places that can refuse somebody: the code
 * step (an address that was already turned away) and the profile step (a date
 * of birth that is too young).
 *
 * Final, and deliberately unhelpful. It says the fact and offers no way back,
 * because the screen must not teach the next attempt: any hint of what would
 * have been acceptable is a hint about which answer gets you through.
 */
export function AgeRefused() {
  const { t } = useTranslation();
  return (
    <div role="alert" className="flex flex-col items-center gap-3 py-10 text-center">
      <UserX className="size-10 text-muted-foreground" aria-hidden />
      <h1 className="text-display">
        {t('auth.youCanTCreateAn', { defaultValue: "You can't create an account" })}
      </h1>
      <p className="text-muted-foreground">
        {t('auth.thanksForYourInterestIn', { defaultValue: 'Thanks for your interest in Nsibi.' })}
      </p>
    </div>
  );
}
